const heightTitleSession = 30
const paddingSessions = '0 3px 3px 3px'
const heightTratamentoEventos = 200

export const TitleSessionSx = {
    // border: '1px solid orange',
    width: '100%',
    height: `${heightTitleSession}px`,
    // display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
}

export const IconTitleSessionSx = {
    height: '100%'
}

export const AbaWebSessionSx = {
    overflow: 'hidden',
    flexGrow: 1,
    padding: paddingSessions
}

export const SessaoTratamentoEventosSx = {
    // border: '1px solid yellow',
    minHeight: `${heightTratamentoEventos}px`,
    width: '100%',
    fontSize: '12px'
}
